function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from 'react';
import { Field, ErrorMessage } from 'formik';
import { useUID } from 'react-uid';
import PropTypes from 'prop-types';

var Select = function Select(_ref) {
  var form = _ref.form,
      field = _ref.field,
      children = _ref.children,
      props = _objectWithoutProperties(_ref, ["form", "field", "children"]);

  var validationClass = '';

  if (form.touched[field.name] && form.errors[field.name]) {
    validationClass = 'is-invalid';
  } else if (form.touched[field.name] && form.values[field.name] != '') {
    validationClass = 'is-valid';
  }

  return /*#__PURE__*/React.createElement("select", _extends({
    className: "custom-select ".concat(validationClass)
  }, field, props), children);
};

var FormikBasicSelect = function FormikBasicSelect(_ref2) {
  var label = _ref2.label,
      name = _ref2.name,
      id = _ref2.id,
      autoComplete = _ref2.autoComplete,
      children = _ref2.children,
      disabled = _ref2.disabled,
      required = _ref2.required,
      multiple = _ref2.multiple;
  var uid = useUID();
  var fieldId = id || "".concat(name, "-").concat(uid);
  return /*#__PURE__*/React.createElement("div", {
    className: "form-group ".concat(required ? 'required' : '')
  }, /*#__PURE__*/React.createElement("label", {
    htmlFor: fieldId
  }, label, required ? /*#__PURE__*/React.createElement("span", {
    className: "sr-only"
  }, " (required)") : null), /*#__PURE__*/React.createElement(Field, {
    component: Select,
    name: name,
    id: fieldId,
    style: {
      width: '100%',
      marginBottom: '1em',
      fontSize: '1rem'
    },
    autoComplete: autoComplete || process.env.NODE_ENV === 'development' ? 'on' : 'off',
    disabled: disabled,
    multiple: multiple
  }, children), /*#__PURE__*/React.createElement(ErrorMessage, {
    name: name,
    component: "div",
    className: "invalid-feedback"
  }));
};

FormikBasicSelect.defaultProps = {
  id: undefined,
  autoComplete: false,
  disabled: false,
  multiple: false,
  required: false
};
export { FormikBasicSelect };